// Libs
import React from 'react'
import classNames from 'classnames'

// CSS
import "./styles.scss"

// Components/Containers
import Button from '../../components/Button'

// Imgs
import chromeImg from '../../assets/chrome.svg'
import firefoxImg from '../../assets/firefox.svg'
import operaImg from '../../assets/opera.svg'

const NotSupported = ({ copied, onCopy }) => {
  return (
    <div className="not-supported">
      <div className="not-supported__modal">
        <p>Não possuimos suporte para o navegador Internet Explorer</p>
        <p>Desculpe o transtorno. Entre com um dos navegadores informados abaixo para obter uma melhor experiência em nossa plataforma.</p>
        <div className="not-supported__download">
          <div onClick={() => window.open('https://www.google.com.br/chrome/index.html', '_blank')}>
            <img src={chromeImg} />
            <p>Chrome</p>
          </div>
          <div onClick={() => window.open('https://www.mozilla.org/pt-BR/firefox/new/', '_blank')}>
            <img src={firefoxImg} />
            <p>Firefox</p>
          </div>
          <div onClick={() => window.open('https://www.opera.com/pt-br', '_blank')}>
            <img src={operaImg} />
            <p>Opera</p>
          </div>
        </div>
        <div
          className="not-supported__button"
          onClick={onCopy}>
          <Button>
            {copied ? 'Copiado!' : 'NavLink de Acesso'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotSupported
